(function(){
'use strict';

angular.module('classy').run(['$templateCache', function ($templateCache) {
  $templateCache.put('global/directives/modal/scModalLink', '<div class="button-container">\n' + '  <a\n' + '    class="modal-link {{ linkClass }}"\n' + '    ng-click="open()"\n' + '    ng-hide="hideButton"\n' + '    data-ng-style="{color: linkColor}"\n' + '    id="{{ linkId }}"\n' + '  >\n' + '    {{ scModalLink }}\n' + '  </a>\n' + '\n' + '  <div ng-transclude class="modal-include"></div>\n' + '</div>\n' + '');
}]);
})();